/** The 31DOC edition a card reads when its page names none. */
export const DOC31_EDITION_ID = '31doc-2026';
